import { getAllowedApps as fetchAllowedApps } from './front_api';

export const ACTIVE_APP_CHANGED_EVENT = 'active-app-changed';

const normalizeAppSearchValue = (value) => String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/gi, '')
    .toLowerCase();

const getStoredAllowedApps = () => {
    try {
        const data = JSON.parse(localStorage.getItem('allowed_apps'));
        return Array.isArray(data) ? data : [];
    } catch (error) {
        console.error('Error parsing allowed apps:', error);
        return [];
    }
};

const getAppSearchValues = (app) => [
    app?.label,
    app?.name,
    app?.code,
    app?.title
].map(normalizeAppSearchValue).filter(Boolean);

async function initAppNames(reload = false) {
    var data = localStorage.getItem('allowed_apps');
    if (data === null || reload) {
        data = await fetchAllowedApps();
        localStorage.setItem('allowed_apps', JSON.stringify(data));
    }
}

const AppIdFromName = () => {
    return Object.fromEntries(
        getStoredAllowedApps().map(app => [app.code, app.id])
    );
}

const AppNameFromID = () => {
    return Object.fromEntries(
        getStoredAllowedApps().map(app => [app.id, app.code])
    );
}

const getAccountManagementApp = () => {
    const exactLabels = ['gestionducompte'];
    const fallbackCodes = ['compte'];

    return getStoredAllowedApps().find((app) => {
        const values = getAppSearchValues(app);
        return values.some((value) => exactLabels.includes(value))
            || normalizeAppSearchValue(app?.code) && fallbackCodes.includes(normalizeAppSearchValue(app.code));
    }) || null;
};

const setActiveApp = (appId) => {
    if (appId === undefined || appId === null) return;

    const nextAppId = String(appId);
    if (nextAppId) {
        localStorage.setItem('active_app', nextAppId);
    } else {
        localStorage.removeItem('active_app');
    }

    window.dispatchEvent(new CustomEvent(ACTIVE_APP_CHANGED_EVENT, {
        detail: { appId: nextAppId }
    }));
};

export { initAppNames, AppIdFromName, AppNameFromID, getAccountManagementApp, getStoredAllowedApps, setActiveApp };
